import React from "react";
import { Navigate, Outlet } from "react-router";
import { useCurrentEmployee } from "../contexts/useCurrentEmployee";
import { ACCESS_GATES, type AccessGate } from "@ds/config/accessGates";

interface RequireRoleProps {
  gate: AccessGate;
}

export const RequireRole: React.FC<RequireRoleProps> = ({ gate }) => {
  const { hasRole } = useCurrentEmployee();

  if (!hasRole(...ACCESS_GATES[gate])) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};
